import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'chevronLeftSmall',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-chevron-left-small wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="m10.294 12 4.575 4.61a.44.44 0 0 1 0 .62l-.635.64-.002.002a.44.44 0 0 1-.622-.002l-5.482-5.523A.44.44 0 0 1 8 12a.44.44 0 0 1 .127-.347L13.61 6.13l.002-.002a.44.44 0 0 1 .622.002l.635.64a.44.44 0 0 1 0 .62z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-chevron-left-small.svg',
    category: 'Core',
    tags: ['navigation', 'arrow'],
};
export default icon;
